import { Translator } from '@itarget/shared'

export const useLoadingTranslation = () => ({
  loading: Translator({ transRef: 'translation.Carregando os recursos.' }).props.children,
})
